import React from "react";
import "./ResultsByDay.scss";
import CandleGraphs from "../../../reusableComponents/CandleGraphs/CandleGraphs";

const ResultsByDay = ({ data }) => {
  // Validate data and extract categories
  const categories = data && typeof data === "object" ? Object.keys(data) : [];

  // Map data for Open and Close series
  const seriesData1 =
    categories.length > 0 ? categories.map((day) => data[day]?.open || 0) : [];
  const seriesData2 =
    categories.length > 0 ? categories.map((day) => data[day]?.close || 0) : [];

  // Structure data for CandleGraphs
  const dayResultOpen = {
    data: seriesData1,
    time: categories,
  };

  const dayResultClose = {
    data: seriesData2,
    time: categories,
  };

  return (
    <div className="resultsByDayMain">
      <div className="trade-reports">
        <div className="header_Wrapper">
          <h2 className="component-heading">Results by close</h2>
        </div>
        <div className="chart-box-wrapper">
            <div className="tabs-wrapper tabs-1">
              <div className="chart-box">
                <CandleGraphs
                  data={dayResultOpen}
                  dataSymbol="amount"
                  graphType="Open"
                  title="Day of the Week"
                  aria-label="Chart showing open results by day"
                />
                <CandleGraphs 
                  data={dayResultClose}
                  dataSymbol="amount"
                  graphType="Close"
                  title="Day of the Week"
                  aria-label="Chart showing close results by day"
                />
              </div>
            </div>
         
        </div>
      </div>
    </div>
  );
};

export default ResultsByDay;
